import QueryParamsSegmentationDirective from './QueryParamsSegmentationDirective';
import QueryParamsData from './QueryParamsData';

export default angular.module('edge.platform.segmentation.queryparams', [])
    .value('queryParamsData', QueryParamsData)
    .directive('gwQueryParamsSegmentation', QueryParamsSegmentationDirective);